<template>
  <section
    id="wrapper"
    :class="{
      wrapper: true,
      'wrapper-app-down': isAppDown
    }"
  >
    <router-view v-slot="{ Component }">
      <mHeader
        v-if="route.meta?.header !== null && route.meta?.header !== undefined && route.meta?.header !== false"
        :hideBack="!route.meta?.header?.back"
        :hideMypage="route.meta?.header?.myPage"
        :hideRefresh="route.meta?.header?.refresh"
        :hideHome="route.meta?.header?.home"
      ></mHeader>
      <div id="container" class="container">
        <component :is="Component" :key="routePath" />
      </div>
    </router-view>
  </section>
</template>

<script setup>
import { onMounted, computed, ref, provide } from 'vue'
import { useAPPstore } from '@/service/stores/cm/cmcm/APP.store'
import { useRoute, useRouter } from 'vue-router'
import mHeader from '@/components/logic/Head.vue'
import { useCMSYAUTHstore } from '@/service/stores/cm/cmsy/AUTH.store'
import { doApplInitBegin } from '@/utils/applInit'

import { datadogRum } from '@datadog/browser-rum'
import { datadogLogs } from '@datadog/browser-logs'
import { commonLang } from '@/utils/constant/messages.constants'

// 글로벌 APP 스토어
const APPstore = useAPPstore()
const authStore = useCMSYAUTHstore()
const route = useRoute()
const router = useRouter()

const routePath = computed(() => route?.path)
const isAppDown = computed(() => route?.meta?.header?.type === 'appdown')

const backKeyCnt = ref(0)

const cachedSysDate = computed(() => authStore.cachedSysDate)

provide('cachedSysDate', cachedSysDate)

const backEventPrc = async function (e) {
  const canGoBack = e.canGoBack && route.name !== 'DLDS-01-V101'

  if (canGoBack) {
    router.back()
  } else if (!canGoBack && $layerPlugin.layerDataList && $layerPlugin.layerDataList.length > 0) {
    $layerPlugin.closeLastLayer($layerPlugin)
  } else {
    if (backKeyCnt.value > 0) {
      $nvBridge.deviceInfo.finish()
    } else {
      $nvBridge.display.showToast('error_gray', commonLang.backeyMessage, 800, 'center')
      backKeyCnt.value++
    }

    setTimeout(() => {
      backKeyCnt.value = 0
    }, 1000)
  }
}

onMounted(async () => {
  if (authStore?.$persistedState?.isReady) {
    await authStore.$persistedState.isReady()
  }
  if ($nvBridge?.deviceInfo?.screenLoadingCompleted) {
    $nvBridge?.deviceInfo?.screenLoadingCompleted()
  }
  if ($nvBridge.emitter) {
    $nvBridge.emitter.on('app.historyBack', backEventPrc)
  }
  console.debug('APPstore : ', APPstore)
  console.debug($nvBridge.deviceInfoData)
  await doApplInitBegin()
})

const testData = () => {
  switch (import.meta.env.VITE_DATADOGRUM_ALLOWEDTRACINGORIGINS) {
    case 'gsthefreshdev':
      return /https:\/\/.*\.gsthefreshdev\.com/
    case 'gsthefreshqa':
      return /https:\/\/.*\.gsthefreshqa\.com/
    case 'gsthefresh':
      return /https:\/\/.*\.gsthefresh\.com/
    default:
      return ''
  }
}

datadogRum.init({
  applicationId: import.meta.env.VITE_DATADOGRUM_APPLICATIONID,
  clientToken: import.meta.env.VITE_DATADOGRUM_CLIENTTOKEN,
  site: 'datadoghq.com',
  service: import.meta.env.VITE_DATADOGRUM_SERVICE,
  env: import.meta.env.VITE_DATADOGRUM_ENV,
  version: import.meta.env.VITE_DATADOGRUM_VERSION,
  sessionSampleRate: 100,
  sessionReplaySampleRate: 100,
  trackUserInteractions: true,
  trackResources: true,
  trackLongTasks: true,
  defaultPrivacyLevel: 'mask-user-input',
  allowedTracingUrls: [testData()],
  trackViewsManually: true
})

datadogLogs.init({
  clientToken: import.meta.env.VITE_DATADOGLOGS_CLIENTTOKEN,
  site: 'datadoghq.com',
  forwardErrorsToLogs: true,
  sessionSampleRate: 100
})
</script>
